export function MobileTerms() {
  return (
    <section className="section">
      <div className="container privacy-page">
        <div className="section-head reveal">
          <p className="eyebrow">Legal</p>
          <h1>Platform Terms of Service and Privacy Policy</h1>
          <p className="privacy-updated">Last updated: April 27, 2026</p>
        </div>

        <div className="privacy-body reveal reveal-delay-1">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the ExpanseFT Platform, Clients, Distributors and its agents ("Clients")
            agree to these Terms. Use is limited to authorized business purposes.
          </p>

          <h2>2. Platform Use</h2>
          <p>
            Use is restricted to account management, transaction processing, and authentication-related
            activities. Unauthorized use is prohibited. ExpanseFT may suspend access without notice if it
            suspects unauthorized use.
          </p>

          <h2>3. Account Security</h2>
          <p>
            Client and agents are responsible for safeguarding credentials and reporting unauthorized access
            immediately.
          </p>

          <h2>4. Client Data</h2>
          <p>
            Client data includes personal identification information required for financial services. Data
            must only be used for authentication, security, and account servicing purposes.
          </p>

          <h2>5. Messaging (SMS and Email - MFA Only)</h2>
          <p>
            ExpanseFT messaging is strictly limited to transactional authentication and security purposes.
          </p>

          <h3>Permitted Uses</h3>
          <ul>
            <li>One-time passcodes (OTP)</li>
            <li>Multi-factor authentication (MFA)</li>
            <li>Login verification</li>
            <li>Security alerts</li>
          </ul>

          <h3>Consent</h3>
          <p>
            Users provide express consent to receive authentication SMS messages by registering for the
            platform and providing their mobile phone number during account enrollment or when enabling
            multi-factor authentication (MFA).
          </p>
          <ul>
            <li>Users provide consent as part of account enrollment and use of services.</li>
            <li>Messaging is required for secure access to accounts.</li>
          </ul>

          <h3>Frequency</h3>
          <ul>
            <li>Messages are triggered by user actions, such as login or transaction activity.</li>
          </ul>

          <h3>Opt-Out</h3>
          <ul>
            <li>Users may reply STOP to opt out.</li>
            <li>Opting out will disable account access requiring authentication.</li>
          </ul>

          <h3>Help</h3>
          <ul>
            <li>Reply HELP for assistance.</li>
          </ul>

          <h3>Disclosures</h3>
          <ul>
            <li>Message and data rates may apply.</li>
            <li>Message frequency varies.</li>
          </ul>

          <h3>Restrictions</h3>
          <ul>
            <li>No marketing or promotional messaging is permitted.</li>
            <li>No third-party sharing of phone numbers for marketing purposes.</li>
          </ul>

          <h3>Delivery Disclaimer</h3>
          <ul>
            <li>Message delivery is not guaranteed due to carrier or network limitations.</li>
          </ul>

          <h2>6. Compliance</h2>
          <p>Client must comply with TCPA, GLBA, BSA/AML, PCI DSS, and applicable privacy laws.</p>

          <h2>7. Suspension</h2>
          <p>Access may be suspended for misuse, security risks, or compliance violations.</p>

          <h2>8. Limitation of Liability</h2>
          <p>
            Platform provided as is. ExpanseFT has no liability for indirect damages. ExpanseFT liability for
            direct damages is limited to $100.
          </p>

          <h2>Privacy Policy</h2>

          <h3>1. Information Collected</h3>
          <p>Includes name, phone number, email, identification data, login activity, and device information.</p>

          <h3>2. Use of Information</h3>
          <p>Used strictly for identity verification, authentication, fraud prevention, and regulatory compliance.</p>

          <h3>3. Sharing</h3>
          <p>
            Information is shared only with issuing banks, processors, and required service providers. No sale
            of personal data.
          </p>

          <h3>4. Data Security</h3>
          <p>
            ExpanseFT maintains administrative, technical, and physical safeguards consistent with industry
            standards.
          </p>

          <h3>5. Data Retention</h3>
          <p>Information is retained in accordance with regulatory and contractual requirements.</p>

          <h3>6. Messaging Privacy</h3>
          <p>Phone numbers and emails are used only for MFA and security alerts and are not used for marketing.</p>

          <h3>7. Consumer Rights</h3>
          <p>Users may request access, correction, or deletion of personal data where permitted by law.</p>

          <h3>8. Contact</h3>
          <p>
            Expanse Financial Technologies, Inc.
            <br />
            1025 Old Country Road
            <br />
            Westbury, NY 11590
            <br />
            <a href="mailto:compliance@expanseft.com">compliance@expanseft.com</a>
          </p>
        </div>
      </div>
    </section>
  );
}
